import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './questions.css';
import { Form, Input, Select, Button, } from 'antd';

import LikeChoices from "./FormLikeChoices";
import DreamForm from "./FormDream";
import InfoForm from "./FormInfo";
import TrueFalse from './FormSkillTrueFalse';
import FormSelf from "./FormSelf";

import {
	questionsList,
} from '../../modules/questions';

class Questions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// mode: "/info",
			mode: null,
			loading: false,
			errormessage:null,
		}
	}

	componentDidMount() {
		// console.log(this.props.questionsData);
		
		if (!this.props.questionsData) {
			this.setState({loading:true});
			this.getCurrentQuestions();
		}
		if(!this.state.mode){
			this.setState({loading:true});
			this.getCurrentQuestions();
		}


	}

	getCurrentQuestions() {
		// console.log("getmode");
		this.props.questionsList().then(
			() => {
				// console.log(this.props.questionsData);
				// if (this.props.questionsData) {
					if(this.props.questionsData){
						if(this.props.questionsData.progress == "done"){
							this.props.history.push('/result');
						}
						else{
							this.setState({ loading:false, mode: this.props.questionsData.progress });
						}
					}
					// console.log(this.state.mode);
				// }
			}
		);
		
	}

	onFinishFailed = errorInfo => {
		// console.log('Failed:', errorInfo);
	};


	formSubmit = () => {

		this.setState({loading:true});
		this.getCurrentQuestions();
		

	}

	handleChange = value => {
		// console.log(value);
	}


	render() {
		const data = {
			en: {

			},
			sc: {

			},
			tc: {
				submit: "下一步"
			},

		};


		// console.log(this.state.mode)



		return (
			<div className="backgroundContainer">

				{(this.state.loading==false)?
					//----------------------------------------------------Info----------------------------------------------------//
					(this.state.mode == "info") ?
						// <div className="questionBlock">
						<InfoForm formSubmit={this.formSubmit.bind(this)} />
						:
						//----------------------------------------------------Dream----------------------------------------------------//
						(this.state.mode == "daydream") ?
							// <div className="questionBlock">
							<DreamForm formSubmit={this.formSubmit.bind(this)} />
							:
							//----------------------------------------------------Activities----------------------------------------------------//
							(this.state.mode == "activities") ?

								<LikeChoices formSubmit={this.formSubmit.bind(this)} />
								:

								(this.state.mode == "competencies") ?
									<TrueFalse formSubmit={this.formSubmit.bind(this)} />

									:
									(this.state.mode == "occupations") ?
										<TrueFalse formSubmit={this.formSubmit.bind(this)} />
										:
										(this.state.mode == "self1") ?
											<FormSelf formSubmit={this.formSubmit.bind(this)} />
											:
											(this.state.mode == "self2") ?
											<FormSelf formSubmit={this.formSubmit.bind(this)} />
											:
											<div></div>
											:
											<div></div>
				}

			</div>
		);
	}
}

const mapStateToProps = state => ({
	questionsData: state.questions.questionsData,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			questionsList,
			
		},
		dispatch
	);

//mapStateToProps should be passed as the 1st argument to connect
export default connect(mapStateToProps, mapDispatchToProps)(Questions);